import styled, { css } from "styled-components";
import { Radio } from "antd";

export const RARadioButton = ({ checked, onChange, title = "", disabled, "data-testid": dataTestId = null }) => (
	<CustomRadioButton
		onChange={() => onChange(!checked)}
		checked={checked}
		disabled={disabled}
		data-testid={dataTestId}
	>
		{title}
	</CustomRadioButton>
);

export const RARadioButtonGroup = ({ value, onChange, options = [] }) => {
	return (
		<Radio.Group onChange={onChange} value={value}>
			{options?.map((opt = {}, key) => (
				<Radio value={opt.value} key={`radio-group-item-${key}`}>
					{opt.label}
				</Radio>
			))}
		</Radio.Group>
	);
};

const CustomRadioButton = styled(Radio)`
	${(props) =>
		props.theme.color_primary_500 &&
		css`
			& .ant-radio-checked .ant-radio-inner {
				border-color: ${props.theme.color_primary_500} !important ;
				background-color: transparent;
			}

			& .ant-radio-checked .ant-radio-inner:after {
				background-color: ${props.theme.color_primary_500};
			}

			& .ant-radio:hover .ant-radio-inner {
				border-color: ${props.theme.color_primary_500};
			}
		`}
`;
